import { render } from "./ActivitiesBody.vue?vue&type=template&id=6cd5689c&scoped=true"
import script from "./ActivitiesBody.vue?vue&type=script&lang=js"
export * from "./ActivitiesBody.vue?vue&type=script&lang=js"

import "./ActivitiesBody.vue?vue&type=style&index=0&id=6cd5689c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd5689c"]])

export default __exports__